import React from 'react';
import { Icon } from '../../components';
import { Copyright, Social, Wrap } from './Footer.styled';
import { convertToRoman } from '../../utils';

export default function Footer() {
	const year = new Date().getFullYear();
	return (
		<Wrap>
			<Social>
				<a
					href="https://www.instagram.com/guitarlos/"
					target="_blank"
					rel="noopener noreferrer"
					className="instagram"
					id="instagram-footer-link"
					title="instagram"
				>
					<Icon type="instagram" size="1.5rem" />
				</a>
				<a
					href="https://www.threads.com/@guitarlos"
					target="_blank"
					rel="noopener noreferrer"
					className="threads"
					id="threads-footer-link"
					title="threads"
				>
					<Icon type="threads" size="1.5rem" />
				</a>
			</Social>
			<Copyright>
				<span> &copy;</span> <span>{convertToRoman(year)} </span>
			</Copyright>
		</Wrap>
	);
}
